// extracted by mini-css-extract-plugin
module.exports = {"list":"styles_list__gEx-1","item":"styles_item__2Gj10","link":"styles_link__3rEdC"};